export enum WidgetInputViewType {
  Text = 'InputText',
  TextArea = 'InputTextArea',
  Number = 'InputNumber',
  Radio = 'InputRadio',
  Checkbox = 'InputCheckbox',
  Select = 'InputSelect',
  Email = 'InputEmail',
  EmailCheck = 'InputEmailCheck',
  Currency = 'InputCurrency',
  Province = 'InputProvince',
  Date = 'InputDate',
  DateInterval = 'InputDateInterval',
  // Address = 'InputAddress',  // TODO: Forse??
  File = 'InputUpload',
  UploadSigned = 'InputUploadSigned',
  FileDrag = 'InputDragUpload',

  List = 'InputList',

  Standard = 'Standard',
  Compact = 'Compact'
}
